import React, { useState, useEffect } from "react";
import "./RelaysCTThree.css";
import RelaysCTTwo from "./RelaysCTTwo";
import RelaysCTFour from "./RelaysCTFour";

const defaultRow = {
  setCurrent: "",
  setTime: "",
  tms: "",
  injectedCurrent2X: "",
  injectedCurrent5X: "",
  injectedCurrent10X: "",
  operatedTime2X: "",
  operatedTime5X: "",
  operatedTime10X: "",
  setVoltage: "",
  phase: "", 
  injectedCurrent: "",
  injectedVoltage: "",
  operatedTime: "", 
};

const sectionConfigs = {
  "O/C 1": {
    phases: ["R", "Y", "B"],
    hasTms: false,
    type: "current",
    hasMultipliers: false,
  },
  "O/C 2": {
    phases: ["R", "Y", "B"],
    hasTms: true,
    type: "current",
    hasMultipliers: true,
  },
  "E/F 1": {
    phases: ["R - N", "Y - N", "B - N"],
    hasTms: false,
    type: "current",
    hasMultipliers: false,
  },
  "E/F 2": {
    phases: ["R - N", "Y - N", "B - N"],
    hasTms: true,
    type: "current",
    hasMultipliers: true,
  },
  "U/V 1": {
    phases: ["R", "Y", "B"],
    hasTms: false,
    type: "voltage",
    hasMultipliers: false,
  },
  "U/V 2": {
    phases: ["R", "Y", "B"],
    hasTms: true,
    type: "voltage",
    hasMultipliers: true,
  },
  "O/V 1": {
    phases: ["R", "Y", "B"],
    hasTms: false,
    type: "voltage",
    hasMultipliers: false,
  },
  "O/V 2": {
    phases: ["R", "Y", "B"],
    hasTms: true,
    type: "voltage",
    hasMultipliers: true,
  },
};

const RelaysCTThree = ({ savedGeneralData = {}, goBack }) => {
  const [formData, setFormData] = useState(
  savedGeneralData?.formData || 
  JSON.parse(localStorage.getItem('relayTestData') || '{}')
);
  const [showBackPage, setShowBackPage] = useState(false);
  const [showNextPage, setShowNextPage] = useState(false);
  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});
  
  
  const [data, setData] = useState(() => {
    const initialData = {};
    Object.entries(sectionConfigs).forEach(([section, config]) => {
      initialData[section] = config.phases.map(() => ({ ...defaultRow }));
    });
    return initialData;
  });

  
const [operationalTimeData, setOperationalTimeData] = useState(() => {
  const savedData = localStorage.getItem('relayCTOperationalTimeData');
  if (savedData) {
    try {
      return JSON.parse(savedData);
    } catch (e) {
      
    }
  }
  

  return {
    oc1: { 
      phase: "R, Y, B", 
      setCurrent: "", 
      setTime: "", 
      injectedCurrent: "", 
      operatedTime: "" 
    },
    oc2: { 
      phase: "R, Y, B", 
      setCurrent: "", 
      tms: "", 
      injectedCurrent2X: "",
      injectedCurrent5X: "",
      injectedCurrent10X: "",
      operatedTime2X: "",
      operatedTime5X: "",
      operatedTime10X: ""
    },
    ef1: { 
      phase: "R - N, Y - N, B - N", 
      setCurrent: "", 
      setTime: "", 
      injectedCurrent: "", 
      operatedTime: ""
    },
    ef2: { 
      phase: "R - N, Y - N, B - N", 
      setCurrent: "", 
      tms: "", 
      injectedCurrent2X: "",
      injectedCurrent5X: "",
      injectedCurrent10X: "",
      operatedTime2X: "",
      operatedTime5X: "",
      operatedTime10X: ""
    },
    uv1: { 
      phase: "R, Y, B", 
      setVoltage: "", 
      setTime: "", 
      injectedVoltage: "", 
      operatedTime: "" 
    },
    uv2: { 
      phase: "R, Y, B", 
      setVoltage: "", 
      setTime: "", 
      injectedVoltage: "", 
      operatedTime: ""
    },
    ov1: { 
      phase: "R, Y, B", 
      setVoltage: "", 
      setTime: "", 
      injectedVoltage: "", 
      operatedTime: "" 
    },
    ov2: { 
      phase: "R, Y, B", 
      setVoltage: "", 
      setTime: "", 
      injectedVoltage: "", 
      operatedTime: ""
    }
  };
});
  


  const calculateAutoValues = (setCurrent, multiplier) => {
    const setCurrentValue = parseFloat(setCurrent);
    if (isNaN(setCurrentValue) || setCurrentValue <= 0) return '';
    return (setCurrentValue * multiplier).toString();
  };

  const updateAutoCalculatedValues = (section, setCurrent) => {
    if (section === 'oc2' || section === 'ef2') {
      const updatedData = { ...operationalTimeData };
      
      updatedData[section].injectedCurrent2X = calculateAutoValues(setCurrent, 2);
      updatedData[section].injectedCurrent5X = calculateAutoValues(setCurrent, 5);
      updatedData[section].injectedCurrent10X = calculateAutoValues(setCurrent, 10);
      
      setOperationalTimeData(updatedData);
      localStorage.setItem('relayCTOperationalTimeData', JSON.stringify(updatedData));
    }
  };

  
  useEffect(() => {
    localStorage.setItem('relayCTOperationalTimeData', JSON.stringify(operationalTimeData));
    localStorage.setItem('relayCTSectionData', JSON.stringify(data));
    localStorage.setItem('relayCTFormData', JSON.stringify(formData));
    localStorage.setItem('relayCTRows', JSON.stringify(rows));
    localStorage.setItem('relayCTGeneralInspection', JSON.stringify(generalInspection));
  }, [operationalTimeData, data, formData, rows, generalInspection]);

  
  const handleChange = (section, index, field, value) => {
    const updatedSection = [...data[section]];
    updatedSection[index][field] = value;
    setData({ ...data, [section]: updatedSection });
  };

  
  const validateNumericInput = (value) => {
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      return value;
    }
    return null; 
  };

  
  const handleMultiplierInputChange = (section, field, value) => {
    const operationalTimeRegex = /^[0-9.]*$/;
    
    if (value === '' || operationalTimeRegex.test(value)) {
      const updatedData = { ...operationalTimeData };
      updatedData[section][field] = value;
      setOperationalTimeData(updatedData);
    }
  };

  
  const handlePhaseSelection = (sectionKey, phase) => {
    setOperationalTimeData(prev => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        phase
      }
    }));
    
    const sectionMap = {
      'oc1': 'O/C 1',
      'oc2': 'O/C 2',
      'ef1': 'E/F 1',
      'ef2': 'E/F 2',
      'uv1': 'U/V 1',
      'uv2': 'U/V 2',
      'ov1': 'O/V 1',
      'ov2': 'O/V 2',
    };
    
    const section = sectionMap[sectionKey];
    if (section && data[section]) {
      const updatedSection = data[section].map((row, idx) => {
        if (idx === 0) {
          return { ...row, phase };
        }
        return row;
      });
      
      setData(prev => ({
        ...prev,
        [section]: updatedSection
      }));
    }
  };

 
  const handleOperationalTimeChange = (sectionKey, field, value) => {
    const operationalTimeRegex = /^[0-9.]*$/;

    if (value === '' || operationalTimeRegex.test(value)) {
      const updatedData = { ...operationalTimeData };
      updatedData[sectionKey][field] = value;
      
      
      if (field === 'setCurrent' && (sectionKey === 'oc2' || sectionKey === 'ef2')) {
        updatedData[sectionKey].injectedCurrent2X = calculateAutoValues(value, 2);
        updatedData[sectionKey].injectedCurrent5X = calculateAutoValues(value, 5);
        updatedData[sectionKey].injectedCurrent10X = calculateAutoValues(value, 10);
      }
      
      setOperationalTimeData(updatedData);
      localStorage.setItem('relayCTOperationalTimeData', JSON.stringify(updatedData));
    }
    
    if (field !== 'phase') {
      const validatedValue = validateNumericInput(value);
      
      if (validatedValue === null) return;
      value = validatedValue;
    }
    
    setOperationalTimeData(prev => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [field]: value
      }
    }));
    
    const sectionMap = {
      'oc1': 'O/C 1',
      'oc2': 'O/C 2',
      'ef1': 'E/F 1',
      'ef2': 'E/F 2',
      'uv1': 'U/V 1',
      'uv2': 'U/V 2',
      'ov1': 'O/V 1',
      'ov2': 'O/V 2',
    };
    
    const section = sectionMap[sectionKey];
    if (section && data[section]) {
      const updatedSection = data[section].map((row, idx) => {
        if (idx === 0) {
          return { ...row, [field]: value };
        }
        return row;
      });
      
      setData(prev => ({
        ...prev,
        [section]: updatedSection
      }));
    }
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleBack = () => {
    setShowBackPage(true);
  };

  const handleNext = (e) => {
    e.preventDefault();
    
    localStorage.setItem('relayCTOperationalTimeData', JSON.stringify(operationalTimeData));
    setShowNextPage(true);
  };

  if (showBackPage) {
    return <RelaysCTTwo goBack={() => setShowBackPage(false)} savedGeneralFormData={formData} />;
  }

  if (showNextPage) {
    return <RelaysCTFour 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection,
        operationalTimeData
      }} 
    />;
  }

  return (
    <div className="rt-5491">

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <h2 className="rt-5484">OPERATIONAL TIME CHARACTERISTIC CHECK</h2>
      <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
        
      </div>

      
      <div className="rt-5492">
        <div className="rt-5493">
          <div className="rt-5494">
            <div className="rt-5495">Reference</div>
            <div className="rt-5497">Phase</div>
            <div className="rt-5498">Set Current(A)</div>
            <div className="rt-5499">Set Time(mSec)</div>
            <div className="rt-5500">Injected Current(A)</div>
            <div className="rt-5501">Operated Time(mSec)</div>
          </div>
          
          <div className="rt-5502">
            <div className="rt-5503">O/C 1</div>
            <div className="rt-5504">
              <button 
                className={`rt-5505 ${operationalTimeData.oc1.phase === 'R' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('oc1', 'R')}
              >R</button>
              <button 
                className={`rt-5505 ${operationalTimeData.oc1.phase === 'Y' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('oc1', 'Y')}
              >Y</button>
              <button 
                className={`rt-5505 ${operationalTimeData.oc1.phase === 'B' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('oc1', 'B')}
              >B</button>
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.oc1.setCurrent || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('oc1', 'setCurrent', e.target.value)}
                placeholder="Enter Set Current(A)" 
              />
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.oc1.setTime || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('oc1', 'setTime', e.target.value)}
                placeholder="Enter Set Time(mSec)" 
              />
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.oc1.injectedCurrent || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('oc1', 'injectedCurrent', e.target.value)}
                placeholder="Enter Injected Current(A)" 
              />
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.oc1.operatedTime || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('oc1', 'operatedTime', e.target.value)}
                placeholder="Enter Operated Time(mSec)" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="rt-5492">
          <div className="rt-5493">
            <div className="rt-5494">
              <div className="rt-5495">Reference</div>
              <div className="rt-5497">Phase</div>
              <div className="rt-5498">Set Current(A)</div>
              <div className="rt-5508">TMS</div>
              <div className="rt-5500">Injected Current(A)</div>
              <div className="rt-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="rt-5502">
              <div className="rt-5503">O/C 2</div>
              <div className="rt-5504">
                <button 
                  className={`rt-5505 ${operationalTimeData.oc2.phase === 'R' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'R')}
                >R</button>
                <button 
                  className={`rt-5505 ${operationalTimeData.oc2.phase === 'Y' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'Y')}
                >Y</button>
                <button 
                  className={`rt-5505 ${operationalTimeData.oc2.phase === 'B' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'B')}
                >B</button>
              </div>
              <div className="rt-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc2', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="rt-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.tms || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc2', 'tms', e.target.value)}
                  placeholder="Enter TMS" 
                />
              </div>
              <div className="rt-5513">
                <div className="rt-5510">
                  <button className="rt-5511">2X</button>
                  <button className="rt-5511">5X</button>
                  <button className="rt-5511">10X</button>
                </div>
              <div className='rt-5520'>
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.injectedCurrent2X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'injectedCurrent2X', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                  readOnly
                />
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.injectedCurrent5X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'injectedCurrent5X', e.target.value)}
                  placeholder="Enter Injected Current(A)"
                  readOnly
                />
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.injectedCurrent10X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'injectedCurrent10X', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                  readOnly
                />
              </div>
              </div>
              <div className="rt-5513">
                <div className="rt-5510">
                  <button className="rt-5511">2X</button>
                  <button className="rt-5511">5X</button>
                  <button className="rt-5511">10X</button>
                </div>
                <div className='rt-5520'>
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.operatedTime2X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'operatedTime2X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.operatedTime5X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'operatedTime5X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)"
                />
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.operatedTime10X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('oc2', 'operatedTime10X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
                </div>
              </div>
            </div>
          </div>
        </div>
      
      <div className="rt-5492">
        <div className="rt-5493">
          <div className="rt-5494">
            <div className="rt-5495">Reference</div>
            <div className="rt-5497">Phase</div>
            <div className="rt-5498">Set Current(A)</div>
            <div className="rt-5499">Set Time(mSec)</div>
            <div className="rt-5500">Injected Current(A)</div>
            <div className="rt-5501">Operated Time(mSec)</div>
          </div>
          
          <div className="rt-5502">
            <div className="rt-5503">E/F 1</div>
            <div className="rt-5504">
              <button 
                className={`rt-5505 rt-5512 ${operationalTimeData.ef1.phase === 'R-N' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('ef1', 'R-N')}
              >R - N</button>
              <button 
                className={`rt-5505 rt-5512 ${operationalTimeData.ef1.phase === 'Y-N' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('ef1', 'Y-N')}
              >Y - N</button>
              <button 
                className={`rt-5505 rt-5512 ${operationalTimeData.ef1.phase === 'B-N' ? 'rt-5506' : ''}`}
                onClick={() => handlePhaseSelection('ef1', 'B-N')}
              >B - N</button>
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.ef1.setCurrent || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('ef1', 'setCurrent', e.target.value)}
                placeholder="Enter Set Current(A)" 
              />
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.ef1.setTime || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('ef1', 'setTime', e.target.value)}
                placeholder="Enter Set Time(mSec)" 
              />
            </div>
            <div className="rt-5507">
              <div className="rt-01">
              <div className="rt-5520 rt-5513">
                <input 
                  type="text" 
                  value={operationalTimeData.ef1.injectedCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef1', 'injectedCurrent', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                />
                
              </div>
              </div>
            </div>
            <div className="rt-5507">
              <input 
                type="text" 
                value={operationalTimeData.ef1.operatedTime || ''}
                maxLength={10}
                onChange={(e) => handleOperationalTimeChange('ef1', 'operatedTime', e.target.value)}
                placeholder="Enter Operated Time(mSec)" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="rt-5492">
          <div className="rt-5493">
            <div className="rt-5494">
              <div className="rt-5495">Reference</div>
              <div className="rt-5497">Phase</div>
              <div className="rt-5498">Set Current(A)</div>
              <div className="rt-5508">TMS</div>
              <div className="rt-5500">Injected Current(A)</div>
              <div className="rt-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="rt-5502">
              <div className="rt-5503">E/F 2</div>
              <div className="rt-5504">
                <button 
                  className={`rt-5505 ${operationalTimeData.ef2.phase === 'R - N' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'R - N')}
                >R - N</button>
                <button 
                  className={`rt-5505 ${operationalTimeData.ef2.phase === 'Y - N' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'Y - N')}
                >Y - N</button>
                <button 
                  className={`rt-5505 ${operationalTimeData.ef2.phase === 'B - N' ? 'rt-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'B - N')}
                >B - N</button>
              </div>
              <div className="rt-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef2', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="rt-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.tms || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef2', 'tms', e.target.value)}
                  placeholder="Enter TMS" 
                />
              </div>
              <div className="rt-5513">
                <div className="rt-5510">
                  <button className="rt-5511">2X</button>
                  <button className="rt-5511">5X</button>
                  <button className="rt-5511">10X</button>
                </div>
              <div className='rt-5520'>
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.injectedCurrent2X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'injectedCurrent2X', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                  readOnly
                />
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.injectedCurrent5X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'injectedCurrent5X', e.target.value)}
                  placeholder="Enter Injected Current(A)"
                  readOnly
                />
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.injectedCurrent10X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'injectedCurrent10X', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                  readOnly
                />
              </div>
              </div>
              <div className="rt-5513">
                <div className="rt-5510">
                  <button className="rt-5511">2X</button>
                  <button className="rt-5511">5X</button>
                  <button className="rt-5511">10X</button>
                </div>
                <div className='rt-5520'>
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.operatedTime2X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'operatedTime2X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.operatedTime5X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'operatedTime5X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)"
                />
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.operatedTime10X || ''}
                  maxLength={10}
                  onChange={(e) => handleMultiplierInputChange('ef2', 'operatedTime10X', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
                </div>
              </div>
            </div>
          </div>
        </div>


<div className="rt-5492">
<div className="rt-5493">
<div className="rt-5494">
<div className="rt-5495">Reference</div>
<div className="rt-5497">Phase</div>
<div className="rt-5498">Set Voltage(V)</div>
<div className="rt-5499">Set Time(mSec)</div>
<div className="rt-5500">Injected Voltage(V)</div>
<div className="rt-5501">Operated Time(mSec)</div>
</div>

<div className="rt-5502">
<div className="rt-5503">U/V 1</div>
<div className="rt-5504">
<button 
  className={`rt-5505 ${operationalTimeData.uv1.phase === 'R' ? 'rt-5506' : ''}`}
  onClick={() => handlePhaseSelection('uv1', 'R')}
>R</button>
<button 
  className={`rt-5505 ${operationalTimeData.uv1.phase === 'Y' ? 'rt-5506' : ''}`}
  onClick={() => handlePhaseSelection('uv1', 'Y')}
>Y</button>
<button 
  className={`rt-5505 ${operationalTimeData.uv1.phase === 'B' ? 'rt-5506' : ''}`}
  onClick={() => handlePhaseSelection('uv1', 'B')}
>B</button>
</div>
<div className="rt-5507">
<input 
  type="text" 
  value={operationalTimeData.uv1.setVoltage || ''}
  maxLength={10}
  onChange={(e) => handleOperationalTimeChange('uv1', 'setVoltage', e.target.value)}
  placeholder="Enter Set Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
  type="text" 
  value={operationalTimeData.uv1.setTime || ''}
  maxLength={10}
  onChange={(e) => handleOperationalTimeChange('uv1', 'setTime', e.target.value)}
  placeholder="Enter Set Time(mSec)" 
/>
</div>
<div className="rt-5507">
<input 
  type="text" 
  value={operationalTimeData.uv1.injectedVoltage || ''}
  maxLength={10}
  onChange={(e) => handleOperationalTimeChange('uv1', 'injectedVoltage', e.target.value)}
  placeholder="Enter Injected Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
  type="text" 
  value={operationalTimeData.uv1.operatedTime || ''}
  maxLength={10}
  onChange={(e) => handleOperationalTimeChange('uv1', 'operatedTime', e.target.value)}
  placeholder="Enter Operated Time(mSec)" 
/>
</div>
</div>
</div>
</div>



<div className="rt-5492">
<div className="rt-5493">
<div className="rt-5494">
<div className="rt-5495">Reference</div>
<div className="rt-5497">Phase</div>
<div className="rt-5498">Set Voltage(V)</div>
<div className="rt-5499">Set Time(mSec)</div>
<div className="rt-5500">Injected Voltage(V)</div>
<div className="rt-5501">Operated Time(mSec)</div>
</div>

<div className="rt-5502">
<div className="rt-5503">U/V 2</div>
<div className="rt-5504">
<button 
className={`rt-5505 ${operationalTimeData.uv2.phase === 'R' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('uv2', 'R')}
>R</button>
<button 
className={`rt-5505 ${operationalTimeData.uv2.phase === 'Y' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('uv2', 'Y')}
>Y</button>
<button 
className={`rt-5505 ${operationalTimeData.uv2.phase === 'B' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('uv2', 'B')}
>B</button>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.uv2.setVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('uv2', 'setVoltage', e.target.value)}
placeholder="Enter Set Voltage(A)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.uv2.setTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('uv2', 'setTime', e.target.value)}
placeholder="Enter Set Time(mSec)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.uv2.injectedVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('uv2', 'injectedVoltage', e.target.value)}
placeholder="Enter Injected Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.uv2.operatedTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('uv2', 'operatedTime', e.target.value)}
placeholder="Enter Operated Time(mSec)" 
/>
</div>
</div>
</div>
</div>



<div className="rt-5492">
<div className="rt-5493">
<div className="rt-5494">
<div className="rt-5495">Reference</div>
<div className="rt-5497">Phase</div>
<div className="rt-5498">Set Voltage(V)</div>
<div className="rt-5499">Set Time(mSec)</div>
<div className="rt-5500">Injected Voltage(V)</div>
<div className="rt-5501">Operated Time(mSec)</div>
</div>

<div className="rt-5502">
<div className="rt-5503">O/V 1</div>
<div className="rt-5504">
<button 
className={`rt-5505 ${operationalTimeData.uv2.phase === 'R' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov1', 'R')}
>R</button>
<button 
className={`rt-5505 ${operationalTimeData.ov1.phase === 'Y' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov1', 'Y')}
>Y</button>
<button 
className={`rt-5505 ${operationalTimeData.ov1.phase === 'B' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov1', 'B')}
>B</button>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov1.setVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov1', 'setVoltage', e.target.value)}
placeholder="Enter Set Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov1.setTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov1', 'setTime', e.target.value)}
placeholder="Enter Set Time(mSec)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov1.injectedVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov1', 'injectedVoltage', e.target.value)}
placeholder="Enter Injected Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov1.operatedTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov1', 'operatedTime', e.target.value)}
placeholder="Enter Operated Time(mSec)" 
/>
</div>
</div>
</div>
</div>


<div className="rt-5492">
<div className="rt-5493">
<div className="rt-5494">
<div className="rt-5495">Reference</div>
<div className="rt-5497">Phase</div>
<div className="rt-5498">Set Voltage(V)</div>
<div className="rt-5499">Set Time(mSec)</div>
<div className="rt-5500">Injected Voltage(V)</div>
<div className="rt-5501">Operated Time(mSec)</div>
</div>

<div className="rt-5502">
<div className="rt-5503">O/V 2</div>
<div className="rt-5504">
<button 
className={`rt-5505 ${operationalTimeData.ov2.phase === 'R' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov2', 'R')}
>R</button>
<button 
className={`rt-5505 ${operationalTimeData.ov2.phase === 'Y' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov2', 'Y')}
>Y</button>
<button 
className={`rt-5505 ${operationalTimeData.ov2.phase === 'B' ? 'rt-5506' : ''}`}
onClick={() => handlePhaseSelection('ov2', 'B')}
>B</button>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov2.setVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov2', 'setVoltage', e.target.value)}
placeholder="Enter Set Voltage(A)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov2.setTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov2', 'setTime', e.target.value)}
placeholder="Enter Set Time(mSec)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov2.injectedVoltage || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov2', 'injectedVoltage', e.target.value)}
placeholder="Enter Injected Voltage(V)" 
/>
</div>
<div className="rt-5507">
<input 
type="text" 
value={operationalTimeData.ov2.operatedTime || ''}
maxLength={10}
onChange={(e) => handleOperationalTimeChange('ov2', 'operatedTime', e.target.value)}
placeholder="Enter Operated Time(mSec)" 
/>
</div>
</div>
</div>
</div>
<div className="rt-5514">
<button type="button" onClick={handleBack} className="rt-5515">Back</button>
<button type="button" onClick={handleNext} className="rt-5515">Next</button>
</div>
</div>

);
};

export default RelaysCTThree;